import axios from 'axios'

class BillTypeFactory {
  async billType () {
    try {
      const url = '/bill_types'
      const response = await axios.get(url)
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async createBillType (data: any) {
    try {
      const url = '/bill_types'
      const response = await axios.post(url, data)
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async updateBillType (id: any, data: any) {
    try {
      const url = `/bill_types/${id}`
      const response = await axios.put(url, data)
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }
}

export const billTypeFactory = new BillTypeFactory()
